import { DataContainerService } from "../datacontainer.service";
import { TransportData } from "../transportdata";

export class SubDashboardResponseView {
  // Must match the collection Name in MainData.Collections
  public static readonly EmbedCollectionName: string = "sub_dashboard";

  register_type: string = "";
  enum_value: number = 0;
  enum_name: string = "";
  count: number = 0;
  level: number = 0;
  sub_list: SubDashboardResponseView[] = [];

  private static FromRaw(raw: any): SubDashboardResponseView {
    const v = new SubDashboardResponseView();
    v.register_type = raw?.register_type ?? "";
    v.enum_value = raw?.enum_value ?? 0;
    v.enum_name = raw?.enum_name ?? "";
    v.count = raw?.count ?? 0;
    v.level = raw?.level ?? 0;
    v.sub_list = (raw?.sub_list ?? []).map((c: any) => SubDashboardResponseView.FromRaw(c));
    return v;
  }

  /** Returns the top-level rows; child rows are inside sub_list */
  public static FromTransportData(td: TransportData): SubDashboardResponseView[] {
    const dcs = DataContainerService.GetInstance();

    if (!dcs.CollectionExists(td.MainData, SubDashboardResponseView.EmbedCollectionName)) {
      return [];
    }

    const coll = dcs.GetCollection(td.MainData, SubDashboardResponseView.EmbedCollectionName)!;
    return (coll.Entries ?? []).map((e: any) => SubDashboardResponseView.FromRaw(e));
  }
}